import WebsiteOverviewPage, {
  websiteOverviewLoader,
} from '@/components/websites/WebsiteOverviewPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$orgId/website/')({
  component: WebsiteOverviewPage,
  loader: websiteOverviewLoader,
})
